import DashboardLayout from '../../components/layout/DashboardLayout';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Upgrade.module.css';
import Icon from '../../components/common/Icon';

const PLANS = [
  {
    name: 'Starter',
    price: '€49',
    period: '/ month',
    tagline: 'For individuals and small survey teams',
    features: [
      '100 GB account storage',
      '50 file downloads / month',
      'Point cloud, 2D & 3D viewers',
      'Standard conversion priority',
      'Email support',
    ],
    highlighted: false,
  },
  {
    name: 'Professional',
    price: '€149',
    period: '/ month',
    tagline: 'For firms running client projects every week',
    features: [
      '1 TB account storage',
      '500 file downloads / month',
      'Scene virtual tours',
      'Scene with plans, BIM and point clouds together',
      '5 Gaussian-splat scenes / month',
      'High conversion priority',
      'Priority support',
    ],
    highlighted: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    tagline: 'For organisations with large-scale scanning programmes',
    features: [
      'Unlimited storage',
      'Unlimited downloads',
      'Unlimited Gaussian-splat scenes',
      'Highest conversion priority',
      'Team management & SSO',
      'Dedicated support manager',
    ],
    highlighted: false,
  },
];

const Upgrade = () => {
  const { user } = useAuth();
  const trialExpired = !!user?.trialEndsAt && new Date(user.trialEndsAt).getTime() <= Date.now();

  return (
    <DashboardLayout>
      <div className={styles.page}>
        <div className={styles.headerBlock}>
          <h2 className="text-3xl font-bold tracking-tight text-on-surface font-headline">Upgrade your plan</h2>
          <p className={styles.subtitle}>
            Pick the plan that fits your projects. Your data stays exactly where it is — upgrading only lifts the limits.
          </p>
          {trialExpired && (
            <div className={styles.expiredNote}>
              <Icon name="lock_clock" className="text-base" />
              Your trial has expired — uploading files and opening the Scene are paused until you upgrade.
            </div>
          )}
        </div>

        <div className={styles.grid}>
          {PLANS.map((plan) => (
            <div key={plan.name} className={`${styles.planCard} ${plan.highlighted ? styles.highlighted : ''}`}>
              {plan.highlighted && <span className={styles.popularBadge}>Most popular</span>}
              <h3 className={styles.planName}>{plan.name}</h3>
              <div className={styles.priceRow}>
                <span className={styles.price}>{plan.price}</span>
                {plan.period && <span className={styles.period}>{plan.period}</span>}
              </div>
              <p className={styles.tagline}>{plan.tagline}</p>
              <ul className={styles.featureList}>
                {plan.features.map((f) => (
                  <li key={f}>
                    <Icon name="check_circle" className="text-base" />
                    {f}
                  </li>
                ))}
              </ul>
              <button className={`${styles.purchaseBtn} ${plan.highlighted ? styles.purchaseBtnPrimary : ''}`}>
                {plan.price === 'Custom' ? 'Contact sales' : `Choose ${plan.name}`}
              </button>
            </div>
          ))}
        </div>

        <p className={styles.footnote}>
          Prices exclude VAT. Need help choosing? Write to us at info@infrio.cloud.
        </p>
      </div>
    </DashboardLayout>
  );
};

export default Upgrade;
